import moment from "moment";
const isOneMinuteOld = (dateValue) =>
  moment.utc().diff(moment.utc(dateValue), "minutes") >= 1;
export { isOneMinuteOld };
